<template>
  <div class="message-wrapper" :class="{'sender':$store.state.session.user.UserID === message.From}">
    <div class="message-container">
      <div class="message-balloon-wrapper" :class="{'messageBalloonMainReverse':$store.state.session.user.UserID === message.From,'messageBalloonMain':$store.state.session.user.UserID !== message.From}" :style="cssProps">
        <ReactionPicker :visible="showReactionPicker" @select="onToggleReaction" @close="closeReactionPicker" />
        <MessageMenuDropDown :message="message" @open-reactions="openReactionPicker" />

        <div :class="{
          speechBubbleTailedLeft:
            $store.state.session.user.UserID !== message.From &&
            !message.continueFromSameBuddy,
          speechBubbleNonTailedLeft:
            $store.state.session.user.UserID !== message.From &&
            message.continueFromSameBuddy,
          speechBubbleTailedRight:
            $store.state.session.user.UserID === message.From &&
            !message.continueFromSameBuddy,
          speechBubbleNonTailedRight:
            $store.state.session.user.UserID === message.From &&
            message.continueFromSameBuddy
        }"
        >
          <ForwardedMessageRow v-if="message.isForwarded" />
          <RepliedMessageRow v-if="message.ReplyMessage" :message="message.ReplyMessage" />
          <div class="senderName" :style="{ color: userColor(message.From) }" v-if="isGroupMessage && $store.state.session.user.UserID !== message.From && !message.continueFromSameBuddy">
            {{ getUserNameDisplay(message.From) }}
          </div>

          <div class="messageTextContainer" :class="{ emojiMessage: isEmojiMessage }">
            <span v-html="getMessageBody()" />
            <span v-if="hasMoreText" class="hasMoreTextLink" @click="currentVisibleChars = currentVisibleChars + 1000">Devamını oku</span>
          </div>

          <MessageBalloonInfoRow :message="message" />
        </div>

        <MessageReactions
          :reactions="message.Reactions"
          :message="message"
          @toggle-reaction="onToggleReaction"
          @open-picker="openReactionPicker"
        />

        <div class="spacer" v-if="$store.state.session.user.UserID !== message.From" />
      </div>
      
      <!-- Message Info Cards - Positioned absolutely -->
      <div class="info-card-container" :class="infoCardClass" v-if="shouldShowInfoCard" :style="infoCardPosition">
        <MessageInfoCard 
          v-if="!isGroupMessage"
          :is-sender="$store.state.session.user.UserID === message.From"
          :current-message="message"
        />
        <GroupMessageInfoCard
          v-if="isGroupMessage"
          :is-sender="$store.state.session.user.UserID === message.From"
          :current-message="message"
          :carrot-position="carrotPosition"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ForwardedMessageRow from './common/ForwardedMessageRow.vue'
import RepliedMessageRow from './common/RepliedMessageRow.vue'
import MessageMenuDropDown from './common/MessageMenuDropDown.vue'
import MessageBalloonInfoRow from './common/MessageBalloonInfoRow.vue'
import MessageInfoCard from './common/MessageInfoCard.vue'
import GroupMessageInfoCard from './common/GroupMessageInfoCard.vue'
import MessageReactions from './common/MessageReactions.vue'
import ReactionPicker from './common/ReactionPicker.vue'
import {
  messageMixin
} from '@/mixins/messageMixin.js'

const emojiRegex = require('emoji-regex')

export default {
  components: {
    ForwardedMessageRow,
    RepliedMessageRow,
    MessageBalloonInfoRow,
    MessageMenuDropDown,
    MessageInfoCard,
    GroupMessageInfoCard,
    MessageReactions,
    ReactionPicker
  },

  mixins: [messageMixin],

  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      currentVisibleChars: 1000,
      hasMoreText: false,
      infoCardStyle: 'inline',
      infoCardLeft: '0px',
      infoCardTop: '50%',
      infoCardBottom: 'auto',
      infoCardTransform: 'translateY(-50%)',
      carrotPosition: 'middle',
      showReactionPicker: false
    }
  },

  computed: {
    cssProps () {
      return {
        '--hasMoreTextLinkColor': this.$config.theme.default.messageContainer
          .messageBalloon.hasMoreTextLinkColor,
        '--outgoingMessageBgColor': this.$config.theme.default.messageContainer
          .messageBalloon.outgoingMessageBgColor
      }
    },
    isEmojiMessage () {
      if (this.message.Body.length > 6) {
        return false
      }

      const regex = emojiRegex()
      let match
      // eslint-disable-next-line
        while (match = regex.exec(this.message.Body)) {
        const emoji = match[0]
        if (emoji === this.message.Body) {
          return true
        }
      }

      return false
    },
    // Mesajın grup mesajı olup olmadığını kontrol et
    isGroupMessage() {
      // Mesajın isGroup özelliği varsa kullan
      if (this.message.isGroup !== undefined) {
        return this.message.isGroup
      }
      
      // Aktif konuşmanın grup olup olmadığını kontrol et
      const activeConversation = this.$store.state.conversation.activeConversation
      return activeConversation && (activeConversation.isGroupConversation || activeConversation.GroupID)
    },
    shouldShowInfoCard() {
      const modal = this.$store.state.display.messageInfoModal
      return modal && 
             modal.isOpen && 
             modal.message && 
             modal.message.MessageID === this.message.MessageID
    },
    infoCardClass() {
      return {
        'info-card-overlay': this.infoCardStyle === 'overlay',
        'info-card-inline': this.infoCardStyle === 'inline'
      }
    },
    infoCardPosition() {
      return {
        left: this.infoCardLeft,
        top: this.infoCardTop,
        bottom: this.infoCardBottom,
        transform: this.infoCardTransform
      }
    }
  },

  created() {
    // Mesaj için isGroup özelliğini ayarla
    if (this.message.isGroup === undefined) {
      const activeConversation = this.$store.state.conversation.activeConversation
      if (activeConversation && (activeConversation.isGroupConversation || activeConversation.GroupID)) {
        this.$set(this.message, 'isGroup', true)
      } else {
        this.$set(this.message, 'isGroup', false)
      }
    }
  },
  
  watch: {
    shouldShowInfoCard(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.checkInfoCardPosition()
        })
      }
    }
  },
  
  mounted() {
    if (this.shouldShowInfoCard) {
      this.checkInfoCardPosition()
    }
  },

  methods: {
    urlify (text) {
      var urlRegex = /(https?:\/\/[^\s]+)/g
      return text.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>'
      })
      // or alternatively
      // return text.replace(urlRegex, '<a href="$1">$1</a>')
    },
    escapeHtml (text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    renderTextSegment (text) {
      return this.urlify(this.escapeHtml(text)).replace(/\n/g, '<br/>').toString()
    },
    infoMsg () {
      this.$refs.menuDropDown.isHidden = true
    },

    replyMsg () {
      this.$refs.menuDropDown.isHidden = true

      this.$store.state.message.ReplyMessage = this.message
      this.$store.state.conversation.activeConversation.newMessage.ReplyMessage = JSON.stringify(this.message)
      this.$store.state.message.isReplyMessageOpen = true
    },

    forwardMsg () {
      this.$refs.menuDropDown.isHidden = true

      let messageToForward = this.message
      this.$store.commit('setMessageToForward', messageToForward)

      this.$store.state.display.modal.viewState = 'forwardMessage'
      this.$modal.show('homepage')
    },

    deleteMsg () {
      this.$refs.menuDropDown.isHidden = true
      this.deleteMessage(this.message)
    },

    permanentDeleteMsg () {
      this.$refs.menuDropDown.isHidden = true
      this.permanentDeleteMessage(this.message)
    },

    /* -------- */

    getMessageBody () {
      let body = this.message.Body.substring(0, this.currentVisibleChars)
      if (this.message.Body.length > body.length) {
        this.hasMoreText = true
        body = body + '...'
      } else {
        this.hasMoreText = false
      }

      if (!Array.isArray(this.message.Mentions) || this.message.Mentions.length === 0) {
        return this.renderTextSegment(body)
      }

      let mentions = [...this.message.Mentions]
        .map(mention => ({
          ...mention,
          Start: parseInt(mention.Start, 10),
          Length: parseInt(mention.Length, 10)
        }))
        .filter(mention => !isNaN(mention.Start) && !isNaN(mention.Length) && mention.Start >= 0 && mention.Length > 0)
        .sort((a, b) => a.Start - b.Start)

      let html = ''
      let cursor = 0

      mentions.forEach(mention => {
        if (mention.Start >= body.length || mention.Start < cursor) {
          return
        }

        let mentionEnd = Math.min(body.length, mention.Start + mention.Length)
        html += this.renderTextSegment(body.substring(cursor, mention.Start))
        html += '<span class="messageMention">' + this.escapeHtml(body.substring(mention.Start, mentionEnd)) + '</span>'
        cursor = mentionEnd
      })

      html += this.renderTextSegment(body.substring(cursor))
      return html
    },
    
    onToggleReaction (emoji) {
      this.toggleReaction(this.message, emoji)
      this.showReactionPicker = false
    },
    openReactionPicker () {
      this.showReactionPicker = true
    },
    closeReactionPicker () {
      this.showReactionPicker = false
    },
    checkInfoCardPosition() {
      this.$nextTick(() => {
        const container = document.getElementById('messagesMainContainer')
        if (!container || !this.$el) return

        const containerRect = container.getBoundingClientRect()
        const messageEl = this.$el.querySelector('.message-balloon-wrapper')

        if (!messageEl) return

        const messageRect = messageEl.getBoundingClientRect()
        const infoCardWidth = this.isGroupMessage ? 330 : 230
        const infoCardHeight = 400 // Maksimum kart yüksekliği

        // Container'ın sol kenarından mesaja olan mesafe
        const spaceOnLeft = messageRect.left - containerRect.left

        // Container'ın altından mesajın altına olan mesafe
        const spaceBelow = containerRect.bottom - messageRect.bottom

        // Mesajın yukarısından container üstüne olan mesafe
        const spaceAbove = messageRect.top - containerRect.top

        // Mesajın solunda info card için pozisyon hesapla
        let leftPosition = -infoCardWidth - 10

        // Eğer container dışına taşacaksa, en sola 10px boşluk bırakarak konumla
        if (spaceOnLeft < infoCardWidth + 20) {
          leftPosition = -(spaceOnLeft - 20)  // 10px yerine 20px bırak (10px container'dan + 10px mesajdan)
          this.infoCardStyle = 'overlay'
        } else {
          this.infoCardStyle = 'inline'
        }

        this.infoCardLeft = `${leftPosition}px`

        // Mesaj konumuna göre kart pozisyonu ve carrot ayarla

        // Eğer mesaj container'ın üst yarısında ise (yukarıda)
        if (messageRect.top < containerRect.top + containerRect.height / 2 && spaceBelow > infoCardHeight / 2) {
          // Kartı mesajla aynı hizaya al (ortadan)
          this.infoCardTop = '50%'
          this.infoCardBottom = 'auto'
          this.infoCardTransform = 'translateY(-50%)'
          this.carrotPosition = 'middle'
        }
        // Mesaj aşağıda - tabanları hizala
        else {
          const messageHeight = messageRect.height

          // Kartın altını mesajın altına hizala
          // Eğer kart mesajdan daha uzunsa yukarı uzanacak
          this.infoCardTop = 'auto'
          this.infoCardBottom = '0px'

          // Container dışına taşma kontrolü
          const cardTopPosition = messageRect.bottom - infoCardHeight
          const overflowTop = containerRect.top - cardTopPosition
          const overflowBottom = (messageRect.bottom - containerRect.bottom)

          if (overflowTop > 0) {
            // Kart üstten taşıyor, aşağı kaydır
            this.infoCardTransform = `translateY(${overflowTop}px)`
            // Carrot'u ayarla - mesaj kartın alt kısmında
            this.carrotPosition = 'bottom'
          } else if (overflowBottom > 0) {
            // Mesaj zaten container'ın altında, kartı yukarı kaydır
            this.infoCardTransform = `translateY(-${overflowBottom}px)`
            this.carrotPosition = 'middle'
          } else {
            // Taşma yok, normal konumla
            this.infoCardTransform = 'none'

            // Carrot pozisyonunu mesajın kart içindeki yerine göre ayarla
            if (infoCardHeight - messageHeight > 200) {
              // Kart mesajdan çok daha uzun, carrot'u aşağı al
              this.carrotPosition = 'bottom'
            } else {
              this.carrotPosition = 'middle'
            }
          }
        }
      })
    }
  }

}

</script>

<style lang="less" scoped>
  @import "../../../../../style/messageBalloon";

  .message-wrapper {
    width: 100%;
    display: flex;
    padding: 0 10px;
    
    &.sender {
      justify-content: flex-end;
    }
  }
  
  .message-container {
    display: inline-block;
    position: relative;
    max-width: calc(100% - 20px);
  }
  
  .info-card-container {
    position: absolute;
    z-index: 10;

    &.info-card-inline {
      // Normal pozisyon
    }

    &.info-card-overlay {
      // Mesajın üstüne binecek şekilde
      background: rgba(255, 255, 255, 0.95);
      border-radius: 12px;
    }
  }
  
  .message-balloon-wrapper {
    display: inline-block;
    min-width: 0;
    max-width: fit-content;
  }

  .hasMoreTextLink {
    color: var(--hasMoreTextLinkColor);
    cursor: pointer;
    margin-left: 10px;
  }

  .emojiMessage {
    font-size: 40px;
    margin-left: 20px;
  }

  ::v-deep .messageMention {
    color: #c62828;
    font-weight: 700;
  }

  /* ------------- */

  .dropDownButtonMain {
    position: absolute;
    right: 5px;
    top: 3px;
    z-index: 20;
  }

  .dropDownBtn {
    width: 10px;
    height: 10px;
    cursor: pointer;
  }

  .messageMenuItem {
    font-size: 12px;
    cursor: pointer;
    background-color: #FFFFFF;
    padding: 10px;
  }

  .messageMenuItem:hover {
    background-color: #F0F0F0;
  }

</style>

<style>
  .messageDropDown-bp__btn {
    border: none !important;
    display: none !important;
  }

</style>

<style>
  br {
    content: "";
    margin: 2em;
    display: block;
    font-size: 24%;
  }

  textarea {
    font-family: "Raleway";
  }

</style>
